import { Mutation, VisitorGroup } from 'graphql/generated/graphqlTypes';
import { removeFields } from 'mocks/graphqlMocks/removeFields';
import { generateMockVisitorGroup } from 'mocks/graphqlMocks/visitorGroup';

export function mockedAddVisitorGroupData(addVisitorGroup: VisitorGroup): Pick<Mutation, 'addVisitorGroup'> {
  return {
    addVisitorGroup
  };
}

// ADD_VISITOR_GROUP_WITH_RETAIL only selects id/name/members/type/externalRef/maxNumberOfMembers
const fieldsToRemoveFromVisitorGroups: (keyof VisitorGroup)[] = [
  'accessGrants',
  'allowedAccessGrants',
  'defaultAccessGrants',
  'isAdminGroup',
  'isQrCodeVisitInviterGroup',
  'memberIds',
  'scheduledAccessGrants',
  'tenantId'
];

export const mockedAddVisitorGroupDataForMutation = mockedAddVisitorGroupData(
  removeFields(
    generateMockVisitorGroup({
      id: 'mockedVisitorGroupIdExternalUsersNew',
      members: [],
      name: 'co-contractors-new',
      maxNumberOfMembers: 2
    }),
    fieldsToRemoveFromVisitorGroups
  )
);
